import axios from "axios";

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api/v1`;

const api = axios.create({ baseURL: BASE });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("rallypointgo_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Force sign-out + redirect when a System Administrator session ends
// (idle timeout or signed in on another device).
api.interceptors.response.use(
  (r) => r,
  (err) => {
    const status = err.response?.status;
    const url = err.config?.url || "";
    const detail = err.response?.data?.detail;
    const isAuthFlow = url.includes("/auth/login") || url.includes("/auth/2fa");
    if (status === 401 && localStorage.getItem("rallypointgo_token") && !isAuthFlow) {
      localStorage.removeItem("rallypointgo_token");
      localStorage.removeItem("rallypointgo_imp_stack");
      const msg = typeof detail === "string" ? detail : "Your session ended. Please sign in again.";
      if (!window.location.pathname.startsWith("/login")) {
        window.location.href = "/login?session=" + encodeURIComponent(msg);
      }
    }
    return Promise.reject(err);
  }
);

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export { api, BASE };
export default api;
